<template>
  <div class="c-select-coupon" @click="openCouponList">
    <div class="img">
      <img src="@/assets/images/vip/discount-i.png" alt />
      <span class="f28 color-333 fb">优惠券</span>
      <span class="d-select" v-if="item.id >= 0">已选推荐优惠</span>
    </div>
    <div class="f26 color-A">
      <span v-if="usageCouponInfo.couponList.length == 0">暂无优惠劵可用</span>
      <span v-else>
        <template v-if="item.id >=0">{{discounted}}</template>
        <template v-else>
          选择优惠劵
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </span>
    </div>
  </div>
  <coupons
    :couponList="usageCouponInfo.couponList"
    :curCoupon="item"
    v-if="showCouponList"
    @select="select"
  ></coupons>
</template>

<script>
import coupons from './coupons.vue'
export default {
  props: {
    usageCouponInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    discounted: {
      type: [Number, String],
      default: ''
    }
  },
  components: { coupons },
  data() {
    return {
      showCouponList: false,
    }
  },
  emits: ['select'],
  methods: {
    openCouponList() {
      if(this.usageCouponInfo.couponList.length == 0) return
      this.showCouponList = true
    },
    select(val) {
      this.showCouponList = false
      this.$emit('select', val)
    },
  },
}
</script>

<style lang="less" scoped>
.c-select-coupon {
  width: 686px;
  height: 110px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 20px;
  margin: 0 32px 0 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img {
    display: flex;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }

    .d-select {
      font-size: 20px;
      color: #ff5500;
      padding: 8px 10px;
      border-radius: 6px;
      margin-left: 18px;
      border: 1px solid #ff5500;
    }
  }
}
</style>
